module.exports = __webpack_public_path__ + "img/Ancho_Ricardo.f6e9c926.png";